import { useCallback } from 'react';
import { supabase } from './supabaseClient';

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
};

export const convertToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

export const uploadFileToSupabase = async (
  file: File,
  path: string,
  userId?: string
): Promise<string | null> => {
  if (!userId) return null;
  
  const allowedTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ];

  if (!allowedTypes.includes(file.type)) {
    throw new Error(`الملف ${file.name} يجب أن يكون PDF أو Word`);
  }

  const filePath = `user-${userId}/${path}/${Date.now()}-${file.name}`;
  const { error } = await supabase.storage
    .from('wafra-files')
    .upload(filePath, file);

  if (error) throw new Error(`Upload failed: ${error.message}`);

  const { data } = supabase.storage
    .from('wafra-files')
    .getPublicUrl(filePath);

  return data.publicUrl;
};

export const truncateText = (text: string, maxLength: number = 100) => {
  return text.length > maxLength 
    ? text.substring(0, maxLength) + '...' 
    : text;
};

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export function timeAgo(dateString: string, t: any) {
  const now = new Date();
  const lastSeen = new Date(dateString);
  const diff = now.getTime() - lastSeen.getTime();

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return t("common.timeAgo.days", { count: days });
  if (hours > 0) return t("common.timeAgo.hours", { count: hours });
  if (minutes > 0) return t("common.timeAgo.minutes", { count: minutes });
  return t("common.timeAgo.seconds", { count: seconds });
}

